import * as consts from 'consts/consts';

import React, { FC, ReactNode } from 'react';
import { useIntl } from 'react-intl';
import Page from '../../Layout/Pages/Page';
import CustomSurveyQuestionsTab from './CustomSurveyQuestionsTab';
import CustomSurveysTab from './CustomSurveysTab';

const CustomSurveysAdministrationPage: FC = () => {
  const { formatMessage } = useIntl();

  const tabs: {
    path: string;
    paths?: string[];
    name: string;
    content: ReactNode;
  }[] = [];

  // Surveys tab (first / default)
  tabs.push({
    path: consts.ADMINISTRATION_CUSTOM_SURVEYS(formatMessage).path,
    paths: [
      consts.ADMINISTRATION_CUSTOM_SURVEYS(formatMessage).path,
      consts.ADMINISTRATION_CUSTOM_SURVEYS_SURVEYS(formatMessage).path,
    ],
    name: consts.ADMINISTRATION_CUSTOM_SURVEYS_SURVEYS(formatMessage).name,
    content: <CustomSurveysTab />,
  });

  // Questions tab (second)
  tabs.push({
    path: consts.ADMINISTRATION_CUSTOM_SURVEYS_QUESTIONS(formatMessage).path,
    name: consts.ADMINISTRATION_CUSTOM_SURVEYS_QUESTIONS(formatMessage).name,
    content: <CustomSurveyQuestionsTab />,
  });

  return (
    <Page
      title={consts.ADMINISTRATION_CUSTOM_SURVEYS(formatMessage).name}
      forceShowTabs={true}
      tabs={tabs}
    />
  );
};

export default React.memo(CustomSurveysAdministrationPage);
